import cx from "classnames";

import LogoSvg from "./logo.svg?react";
import LogoLetterSvg from "./logo_p.svg?react";

import "./Logo.scss";

type LogoProps = {
  className?: string;
  variant?: "default" | "small";
  url?: string;
};

const Logo = ({ className, variant = "default", url }: LogoProps) => {
  const logoElement = variant === "small"
    ? <LogoLetterSvg className={cx("Logo--Small", className)} />
    : <LogoSvg className={cx("Logo", className)} />;

  if (url) {
    return (
      <a href={url} className="Logo-Link">
        {logoElement}
      </a>
    );
  }

  return logoElement;
};

export { Logo };
